import axios from '@/utils/ajax';

/**
 * vip 相关接口
 */

// 联系客服授权 vip
export const authorizeVip = () => {
    return axios({
        url: '/bp/api/vip/genvip',
        method: 'post'
    });
};
